module.exports = __webpack_public_path__ + "img/icon_book.b1dafb34.svg";